import styled from 'styled-components'
import {liStyle, olStyle, ulStyle} from './List.syled'

export const UnorderedList = styled.ul`
  ${ulStyle}
`

export const OrderedList = styled.ol`
  ${olStyle}
`

export const ListItem = styled.li`
  ${liStyle}
`
